import { z } from 'zod';

export const ATTENDANCE_STATUSES = [
  'present',
  'late',
  'absent',
  'half_day',
  'auto_logout',
  'on_leave',
] as const;
export const attendanceStatusEnum = z.enum(ATTENDANCE_STATUSES);
export type AttendanceStatus = z.infer<typeof attendanceStatusEnum>;

export const CORRECTION_STATUSES = ['pending', 'approved', 'rejected'] as const;
export const correctionStatusEnum = z.enum(CORRECTION_STATUSES);
export type CorrectionStatus = z.infer<typeof correctionStatusEnum>;

export const checkInSchema = z.object({
  latitude: z.number().min(-90).max(90).optional(),
  longitude: z.number().min(-180).max(180).optional(),
  locationAddress: z.string().trim().max(300).optional(),
});

export type CheckInInput = z.infer<typeof checkInSchema>;

/** Sent once a minute by the desktop tracker app while the user looks active. */
export const heartbeatSchema = z.object({
  source: z.string().trim().max(60).optional(),
});

export type HeartbeatInput = z.infer<typeof heartbeatSchema>;

export const correctionRequestSchema = z.object({
  note: z.string().trim().min(5, 'Explain what needs correcting (min 5 characters)').max(500),
  requestedLoginTime: z.coerce.date().optional(),
  requestedLogoutTime: z.coerce.date().optional(),
});

export type CorrectionRequestInput = z.infer<typeof correctionRequestSchema>;

export const resolveCorrectionSchema = z.object({
  status: z.enum(['approved', 'rejected']),
  responseNote: z.string().trim().max(500).optional(),
});

export type ResolveCorrectionInput = z.infer<typeof resolveCorrectionSchema>;

export const attendanceListQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(100).default(20),
  userId: z.string().optional(),
  status: attendanceStatusEnum.optional(),
  from: z.coerce.date().optional(),
  to: z.coerce.date().optional(),
});

export type AttendanceListQuery = z.infer<typeof attendanceListQuerySchema>;
